import * as Icons from "@nova/component-icons"
import { ContextMenuItem } from "features/data-management/workspace/TODO-put-in-package/ContextMenu"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { LayerPluginSpec } from "plugins/plugin-registry"
import { removeLayerFromSelection, selectSelectedLayerIds, setRenamingLayerId } from "../slice.new"
import { useMoveActions } from "./genericContextMenuSections"
import {
    getGenericConfirmationModalComponent,
    useConfirmationModalContext,
} from "features/modals/WorkspaceConfirmationModalV2"
import { useIsEditor } from "tools/hooks/useIsEditor"
import { SidePanelLayerOrGroup } from "@nova/constants"
import { useDataTransfer } from "integrations/transfer/useDataTransfer"

export function getUsePdfContextMenuSections(spec: LayerPluginSpec) {
    return function usePdfContextMenuSections(id: string, sortedEntities: SidePanelLayerOrGroup[]) {
        const dispatch = useAppDispatch()
        const entity = useAppSelector(spec.selectSingleEntity(id))
        const confirmationModal = useConfirmationModalContext()
        const selectedLayerIds = useAppSelector(selectSelectedLayerIds)
        const isEditor = useIsEditor()
        const actions = [] as ContextMenuItem[][]
        const { canTransfer, transfer, integrationName } = useDataTransfer()
        if (isEditor) {
            const editorActions = []
            editorActions.push({
                title: "Rename",
                onClick: () => {
                    dispatch(setRenamingLayerId({ id }))
                },
                Icon: Icons.Pencil,
            })
            if (canTransfer) {
                editorActions.push({
                    title: `Transfer to ${integrationName}`,
                    onClick: () => {
                        transfer("pdf", [id])
                    },
                    Icon: Icons.Backup,
                })
            }
            actions.push(editorActions)
        }
        const moveActions = useMoveActions({
            spec,
            id,
            mode: "PDFs",
            sortedEntities,
        })
        if (moveActions.length) {
            actions.push(moveActions)
        }
        if (isEditor) {
            actions.push([
                {
                    title: "Delete",
                    onClick: async () => {
                        const didConfirm = await confirmationModal.confirm({
                            RenderComponent: getGenericConfirmationModalComponent({
                                title: "Delete Selection?",
                                message: `This will delete ${entity.name}, do you want to proceed?`,
                            }),
                        })
                        if (!didConfirm) return
                        dispatch(spec.deleteAction({ id }))
                        if (selectedLayerIds.includes(id)) {
                            dispatch(removeLayerFromSelection({ id }))
                        }
                    },
                    Icon: Icons.Trash,
                    isDestructive: true,
                },
            ])
        }
        return actions
    }
}
